<template>
  <el-container class="container">
    <el-header>
      <my-header @selected="onSelected"></my-header>
    </el-header>
    <!-- <img src="https://zhenbaojia.obs.cn-south-1.myhuaweicloud.com:443/2021-03-27-1616824123.jpg" width="700" alt=""> -->
    <el-scrollbar style="height: 100%" id="elScrollbar" ref="elScrollbar">
      <el-main>
        <my-main :type="type" style="height: 100%"></my-main>
      </el-main>
    </el-scrollbar>
    <el-footer height="36px">
      <my-footer></my-footer>
    </el-footer>
  </el-container>
</template>

<script>
import { mapMutations } from "vuex";
import myHeader from "../components/my-header/my-header";
import myMain from "../components/my-main/my-main";
import myFooter from "../components/my-footer/my-footer";
export default {
  name: "index",
  components: {
    myHeader,
    myMain,
    myFooter,
  },
  data() {
    return {
      type: "el-zoom-in-center",
    };
  },
  created() {
    //window.addEventListener('scroll',this.onScroll,true)
    let strong = window.localStorage;
    let obj = JSON.parse(strong.getItem("auth_permissions"));
    // this.$router.go(0)
  },
  methods: {
    ...mapMutations(["SetScrollbar"]),
    onScroll(e) {
      //this.SetScrollbar(this.$refs['elScrollbar'].moveY);
    },
    onSelected(e) {
      this.type = e.type;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  .el-main {
    padding: 0;
    height: 100%;
  }
  height: 100%;
  .el-header {
    background-color: #485b7f;
  }
  .el-footer {
    background-color: #232c3d;
  }
}
</style>
<style lang="scss">
#elScrollbar .el-scrollbar__wrap:first-child {
  overflow-x: hidden;
}
.my-el-scrollbar .el-scrollbar__wrap:first-child {
  overflow-x: hidden;
}
.el-dialog__wrapper {
  z-index: 100 !important;
}
.v-modal {
  z-index: 10 !important;
}
</style>
